const routes = [
  {
    index: true,
    label: 'Simon Hewins',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'CV',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
